import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-toggle-right-icon',
  templateUrl: './text-toggle-right.component.html'
})
export class TextToggleRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
